/**
 * Base URL for print-preview report data fetches.
 *
 * Puppeteer in sftp-renderer Docker opens the dev app at host.docker.internal:1212.
 * Client-side fetches to VITE_SUPABASE_URL (127.0.0.1:54321) fail from inside the
 * container. In dev, route through the Vite proxy instead.
 */
export function resolveReportDataApiBase(): string {
    const configured = import.meta.env.VITE_SUPABASE_URL as string;

    if (import.meta.env.DEV && typeof window !== "undefined" && window.location.hostname === "host.docker.internal") {
        return "/local-supabase";
    }

    return configured;
}
